import { Drawer, DrawerBody, DrawerHeader, DrawerHeading, Id, Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { contactUpdateInquiryService } from "../../../../shared/api/contactUpdateInquiryService";
import { ContactUpdateDiffDrawerContent } from "./ContactUpdateDiffDrawerContent";

interface Props {
	open: boolean;
	onClose: () => void;
	onClosed: () => void;
	inquiryId: Id;
	contactId: Id;
}

const Center = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 2rem;
`;

const StyledDrawer = styled(Drawer)`
	width: 800px;
`;

export const ContactUpdateDiffDrawer: FC<Props> = ({ open, inquiryId, contactId, onClose, onClosed }) => {
	const { t } = useTranslation();
	const { data } = useQuery({
		queryKey: contactUpdateInquiryService.contactDiffKey(inquiryId, contactId),
		queryFn: () => contactUpdateInquiryService.contactDiff(inquiryId, contactId).then((r) => r.data.data),
	});

	return (
		<StyledDrawer open={open} onClose={onClose} onClosed={onClosed}>
			{!data ? (
				<>
					<DrawerHeader onClose={onClose}>
						<DrawerHeading>{t("Update inquiry")}</DrawerHeading>
					</DrawerHeader>
					<DrawerBody>
						<Center>
							<Loading />
						</Center>
					</DrawerBody>
				</>
			) : (
				<ContactUpdateDiffDrawerContent onClose={onClose} contactUpdateDiff={data} inquiryId={inquiryId} />
			)}
		</StyledDrawer>
	);
};
